import { render, staticRenderFns } from "./banli.vue?vue&type=template&id=34d78438&scoped=true&"
import script from "./banli.vue?vue&type=script&lang=js&"
export * from "./banli.vue?vue&type=script&lang=js&"
import style0 from "./banli.vue?vue&type=style&index=0&id=34d78438&prod&lang=less&scoped=true&"
import style1 from "./banli.vue?vue&type=style&index=1&id=34d78438&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d78438",
  null
  
)

export default component.exports